<template>
  <div class="h-full position-relative model-doc-preview" v-loading="isShowWaitLayer">
    <el-row class="h-full">
      <el-col v-if="spanLeft !== 0" :span="spanLeft" class="h-full position-relative">
        <model-view
          v-if="modelTypes.includes(mainFileType) || mainFileType === 'scene'"
          ref="modelView"
          class="bg-white"
          style="overflow: hidden"
          playerEngineId="engineId"
          :cloudRender="cloudRender"
          :code="currentCode"
          :modelProps="modelProps"
          :gisAttrKeys="gisAttrKeys"
          :showDocComponent="showDocComponent"
          :docHeight="docHeight"
          :modelParams="modelList"
          :modelName="currentDocumentId"
          :basicTabBar="basicTabBar"
          :codeChangeType="codeChangeType"
          :businessTabBar="businessTabBar"
          :businessTabInfo="businessTabInfo"
          :showPlayerSysSetting="false"
          :currentCreateNode="currentCreateNode"
          :currentEditMoment="currentEditMoment"
          :showCloseScreen="showCloseScreen"
          @loadingSwitch="loadingSwitch"
          @closeSystemSetting="closeSetting"
          @annotationClick="annotationClick"
          @sendBasicComponents="sendBasicComponents"
          @sendPlayer="sendPlayer"
          @modelClick="modelClick"
          @tagsBusinessClick="tagsBusinessClick(arguments, 'main')"
          @LoadedAllModel="LoadedAllModel"
          @handleNodeClick="handleNodeClick"
          @modifyNodeEnd="modifyNodeEnd"
          @updateModelNode="updateModelNode"
          @currentCodeChange="currentCodeChange"
        >
          <PipeExtraction
            @changeModelData="changeModelData"
            :player="mainPlayer"
            :cloudRender="cloudRender"
            @showBitRelational="relation = true"
            @getModelData="getModelData"
            v-if="showPipeExtraction"
          ></PipeExtraction>
          <PipeFlowAnalysis
            @changeModelData="changeModelData"
            :player="mainPlayer"
            :cloudRender="cloudRender"
            @showBitRelational="relation = true"
            @getModelData="getModelData"
            @loadingSwitch="loadingSwitch"
            v-if="showPipeFlowAnalysis"
          >
          </PipeFlowAnalysis>
          <template>
            <div
              class="iconfont icon-line-close absolute right-20px top-98px text-[#fff] z-990 cursor-pointer"
              @click="relation = false"
              v-show="relation"
            ></div>
            <bit-relational
              ref="bitRelational"
              :heightObj="bitHeight"
              :bitRelationalData="bitRelationalData"
              :tagCode="bitModelCode"
              :tagId="tagId"
              :isTag="isTag"
              :fileId="currentModel.fileId"
              @currentCodeChange="currentCodeChange"
              @getModelData="getModelData"
              @setObjectNode="setObjectNode"
              @splitScreen="splitScreen"
              @showBit="showBit"
              class="bit-relational-box"
              v-show="relation"
            ></bit-relational>
          </template>
          <!-- 业务组件弹框 -->
          <DialogTabBar
            :top="componentTop"
            direction="right"
            :currentCom="showBusinessComponents"
            :dialogList="openDialogList"
            @switchDialog="switchDialog"
            v-if="showBusinessDialog"
          ></DialogTabBar>
          <keep-alive
            :include="
              _.map(openDialogList, (item) => {
                return item.val
              }).join(',')
            "
          >
            <component
              :isShowBasicCom="!!basicComponents || showDocComponent"
              :is="showBusinessComponents"
              :tagCode="currentCode"
              :player="mainPlayer"
              :loadedModel="loadedModel"
              :height="componentHeight"
              :top="componentTop"
              :allConvertNodeList="allConvertNodeList"
              :currentModel="currentModel"
              :sceneOpenType="modelProps.sceneOpenType"
              :documentId="currentModel.documentId"
              :currentNodeData="currentEngineerNode"
              :watchNodeModify="watchNodeModifyTiming"
              v-if="showBusinessDialog"
              @splitScreen="splitScreen"
              @currentCodeChange="currentCodeChange"
              @showMarker="showMarker(arguments, 'main')"
              @closeComponent="closeBusinessComponent"
              @updateEditTree="updateEditTree"
            ></component>
          </keep-alive>
        </model-view>
        <file-preview
          v-else-if="fileTypeList.includes(mainFileType)"
          :fileProps="fileMainProps"
          :imgType="imgTypeList"
          :tagCode="currentCode"
          @loadFile="loadFile"
          @svgClick="svgClick"
        ></file-preview>
      </el-col>
      <el-col v-if="spanRight !== 0" :span="spanRight" class="h-full position-relative">
        <model-view
          v-if="splitFileType === 'pr' || mainFileType === 'pprj' || splitFileType === 'scene'"
          ref="splitModelView"
          class="bg-white"
          :gisAttrKeys="gisAttrKeys"
          :cloudRender="newCloudRender"
          :modelParams="modelSplitList"
          :modelProps="modelSplitProps"
          :showCloseScreen="showCloseScreen"
          playerEngineId="splitEngineId"
          :modelName="currentSplitDocumentId"
          :basicTabBar="basicTabBar"
        ></model-view>
        <file-preview
          v-else-if="fileTypeList.includes(splitFileType)"
          :imgType="imgTypeList"
          :fileProps="fileSplitProps"
          :tagCode="currentCode"
          @loadFile="loadFile"
          @svgClick="svgClick"
          @captureImage="captureImage"
          @showMarker="showMarker(arguments, 'split')"
        ></file-preview>
        <!-- 截图等待时的透明图层 -->
        <div class="h-full w-full wait_layer" v-if="isShowWaitLayer"></div>
      </el-col>
    </el-row>
    <!-- 收缩分屏按钮 -->
    <div
      v-if="showCloseScreen"
      class="
        w-30px
        h-30px
        i-h-30px
        absolute
        top-0
        right-0
        text-center
        cursor-pointer
        leading-30px
        bg-[#e41b1b]
      "
      @click="showCloseScreen = !showCloseScreen"
    >
      <i class="icon el-icon-close text-18px text-white"></i>
    </div>
    <!-- <el-tooltip
      v-if="splitFileType"
      :content="showCloseScreen ? '缩起分屏' : '展开分屏'"
      placement="top"
      :open-delay="1000"
    >
      <span
        class="iconfont icon-line-circleQuit text-color-blue fz-16 position-absolute split_icon"
        :style="!showCloseScreen ? 'transform:rotate(180deg)' : ''"
        @click="showCloseScreen = !showCloseScreen"
      ></span>
    </el-tooltip> -->

    <!-- 切换模型时的加载动画，提醒切换过程不要操作 -->
    <div class="model_switch_loading" v-if="animationLoading && loadedModel">
      <div class="switch_loading_box">
        <div class="loading_action">
          <div class="inner one"></div>
          <div class="inner two"></div>
          <div class="inner three"></div>
          <div class="inner four"></div>
        </div>
        <div class="switch_loading_title">
          {{ loadingTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentManagementService from '@/services/documentManagement'
import SceneCenter from '@/services/sceneCenter'
import addService from '@/services/addManageService'
import ApiMixinModelCenter from '@/assets/js/api/modelCenter'
import { initPlayer } from '@/views/baochang/documentBrowseDemo/js/drawUtil'
import { instance as cloudRender, cloudRender as CloudRender } from 'wiz-cloud-render-vulkan'
import docViewTabBarTactics from '../documentBrowseVk/js/docViewTabBarTactics'

const ModelView = () => {
  return import('../../components/model/ModelViewVk')
}
const FilePreview = () => {
  return import('../documentBrowseVk/components/FilePreview')
}
const BitRelational = () => {
  return import('../documentBrowseVk/components/BitRelational')
}
const DialogTabBar = () => {
  return import('@/components/model/DialogTabBar')
}
const PipeExtraction = () => {
  return import('./components/pipeExtraction')
}
const PipeFlowAnalysis = () => {
  return import('./components/pipeFlowAnalysis')
}

export default {
  name: 'index',
  mixins: [ApiMixinModelCenter],
  components: {
    ModelView,
    BitRelational,
    FilePreview,
    DialogTabBar,
    PipeExtraction,
    PipeFlowAnalysis,
  },
  data() {
    return {
      modelTypes: [
        'pr',
        'pprj',
        'rvm',
        'fbx',
        'vue',
        'shp',
        'zip',
        'gltf',
        'glb',
        'las',
        'prd',
        'xml',
        'obj',
        '3mf',
        'blend',
        '3ds',
        'stl',
        'dae',
        'fbxSkeleton',
        'step',
        'stp',
      ],
      relation: false, // 是否需要展示移交关系
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      animationLoading: false, // 动画状态
      loadingTitle: null, // 动画名称
      // 二三维截图部分数据
      showMainEditPhoto: false, // 是否显示截图蒙层
      showSplitEditPhoto: false, // 分屏是否显示截图蒙层
      MainEditViewProps: {
        // 主屏截图编辑需要的信息
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      },
      SplitEditViewProps: {
        // 分屏截图编辑需要的信息
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      },
      newCloudRender: null, // 分屏的sdk
      rotationAngle: 0, // 默认旋转角度
      modelSplitProps: {
        defaultModelId: '', // 默认加载的模型id
        sceneOpenType: '', // 加载场景类型
      },
      modelSplitList: [],
      currentSplitDocumentId: '',
      imgTypeList: ['png', 'jpg', 'gig', 'bmp', 'tif'], // 图片类型集合
      // 模型加载相关start
      modelProps: {
        defaultModelId: '', // 默认加载的模型id
        sceneOpenType: '', // 加载场景类型
      },
      gisAttrKeys: [], // gis加载所需属性字段
      modelList: [], // 模型列表
      loadedModel: false, // 模型是否加载完成
      basicTabBar: [
        {
          name: '模型树',
          val: 'ModelTree',
          maxHeight: '40rem',
          minHeight: '40rem',
          iconName: 'icon-line-tree',
          unAllowCoexistCom: [],
        },
        {
          name: '点选',
          val: 'system.Pickup',
          iconName: 'icon-yxr-clickSelect',
          unAllowCoexistCom: [],
        },
        {
          name: '移动',
          val: 'system.Move',
          iconName: 'icon-yxr-move',
          unAllowCoexistCom: [],
          hoverWidth: 200,
          children: [
            {
              name: '移动',
              val: 'system.Move',
              iconName: 'icon-yxr-move',
              unAllowCoexistCom: [],
            },
            {
              name: '旋转',
              val: 'system.Rotate',
              iconName: 'icon-yxr-rotate',
              unAllowCoexistCom: [],
            },
            {
              name: '驻点观察',
              val: 'system.ToolFixedObservation',
              iconName: 'icon-line-patrolInspection',
              unAllowCoexistCom: [],
            },
            {
              name: '缩放',
              val: 'system.Scale',
              iconName: 'icon-yxr-zoom',
              unAllowCoexistCom: [],
            },
            {
              name: '居中',
              val: 'system.PickupCenter',
              iconName: 'icon-yxr-center',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '隐藏',
          val: 'system.ToolHideModel',
          iconName: 'icon-line-hide',
          hoverWidth: 151,
          unAllowCoexistCom: [],
          children: [
            {
              name: '隐藏',
              val: 'system.ToolHideModel',
              iconName: 'icon-line-hide',
              unAllowCoexistCom: [],
            },
            {
              name: '显示上一个',
              val: 'system.ToolShowModel',
              iconName: 'icon-yxr-showPrevious',
              unAllowCoexistCom: [],
            },
            {
              name: '显示所有已隐藏',
              val: 'system.ToolShowAll',
              iconName: 'icon-yxr-showAllHidden',
              unAllowCoexistCom: [],
            },
            {
              name: '空间交换',
              val: 'system.ToolHideModelSpaceSwap',
              iconName: 'icon-line-refresh',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '全局剖切',
          val: 'AllClip',
          maxHeight: '45rem',
          minHeight: '6rem',
          iconName: 'icon-yxr-globalSection',
          unAllowCoexistCom: [],
          children: [
            {
              name: '全局剖切',
              val: 'AllClip',
              maxHeight: '45rem',
              minHeight: '6rem',
              iconName: 'icon-yxr-globalSection',
              unAllowCoexistCom: [],
            },
            {
              name: '局部剖切',
              val: 'PartClipBox',
              iconName: 'icon-yxr-partialSection',
              maxHeight: '45rem',
              minHeight: '6rem',
              unAllowCoexistCom: [],
            },
            {
              name: '三面剖切',
              val: 'ThreePanel',
              unAllowCoexistCom: [],
              maxHeight: '45rem',
              minHeight: '6rem',
              iconName: 'icon-yxr-cutThreeSides',
            },
          ],
        },
        {
          name: '第一人称漫游',
          val: 'system.walk.first',
          iconName: 'icon-yxr-firstPersonRoaming',
          unAllowCoexistCom: [],
          children: [
            {
              name: '第一人称漫游',
              val: 'system.walk.first',
              iconName: 'icon-yxr-firstPersonRoaming',
              unAllowCoexistCom: [],
            },
            {
              name: '第三人称漫游',
              val: 'system.walk.third',
              iconName: 'icon-yxr-thirdPersonRoaming',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '两点测量',
          val: 'M_Line',
          iconName: 'icon-yxr-twoPointMeasurement',
          hoverWidth: 310,
          unAllowCoexistCom: [],
          children: [
            {
              name: '两点测量',
              val: 'M_Line',
              iconName: 'icon-yxr-twoPointMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '多点测量',
              val: 'M_Point',
              iconName: 'icon-yxr-multipointMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '高度测量',
              val: 'M_Vertical',
              iconName: 'icon-yxr-heightMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '立体测量',
              val: 'M_Stereo',
              iconName: 'icon-yxr-stereometry',
              unAllowCoexistCom: [],
            },
            {
              name: '角度测量',
              val: 'M_Angel',
              iconName: 'icon-yxr-angleMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '面积测量',
              val: 'M_Area',
              iconName: 'icon-yxr-areaMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '轴距测量',
              val: 'M_WheelBase',
              iconName: 'icon-yxr-wheelbaseMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '清除测量结果',
              val: 'M_None',
              iconName: 'icon-line-delete',
              unAllowCoexistCom: [],
            },
          ],
        },
      ],
      fileDetailList: [], // 加载的模型 or 文件详细信息
      // 模型加载相关end
      mainPlayer: null, // 文件加载完成时player实例 主屏
      currentCode: '', // 当前点击的code
      mainFileType: '', // 主屏的文件类型
      splitFileType: '', // 分屏的文件类型
      // 文件加载相关 start
      fileSplitProps: {
        fileName: '',
        fileType: '',
        fileUrl: '',
        fileId: '',
      },
      fileMainProps: {
        fileName: '',
        fileType: '',
        fileUrl: '',
        fileId: '',
      },
      fileTypeList: ['svg', 'pdf', 'wizdrawing', 'png', 'jpg', 'gif', 'bmp', 'tif', 'mp4'], // 文件加载支持的类型
      // 文件加载相关 end
      bitRelationalData: {},
      spanRight: 0,
      spanLeft: 24,
      showCloseScreen: false, // 是否显示分屏
      // 业务相关的
      showBusinessComponents: '',
      showBusinessDialog: false,
      docModelCode: '', // 文档信息接收模型code
      bitModelCode: '', // 位号基本信息接收模型code
      currentDocumentId: '', // 当前的DocumentId
      currentModel: {}, // 当前选中的模型信息，或场景中默认加载的模型信息
      curModelStandardId: '',
      componentHeight: '',
      showDocComponent: false,
      showBitComponent: false,
      showModelEditTool: false,
      codeChangeType: '', // code变化是由什么触发的
      docHeight: {
        minHeight: '30rem',
        maxHeight: '40rem',
        isZoom: false,
      },
      bitHeight: {
        minHeight: '26.5rem',
        maxHeight: '39.2rem',
        isZoom: false,
      },
      businessTabBar: [],
      businessTabInfo: {
        selectBusinessList: [], // 选中的业务list
        currentDialog: {
          name: '',
          val: '',
          iconName: '',
          activeIconName: '',
        }, // 当前激活的弹框信息
      },
      openDialogList: [], // 已打开的业务弹框列表
      showDialogCom: [],
      // 无需打开弹框的组件
      unOpenDialog: [],
      basicComponents: '', // 当前显示的基本弹框组件
      isShowWaitLayer: false,
      backgroundOffsetX: 0, // 顶部图片偏移量
      showPlayerSetting: false,
      currentEngineerNode: {},
      currentCreateNode: null, // 新添加的模型节点
      watchNodeModifyTiming: {}, // 模型节点编辑监听
      currentEditMoment: 0, // 每次执行节点编辑的时间
      allConvertNodeList: [], // 组态管理里面存的流向映射表
      tagId: '', // 位号id
      isTag: false, // 是否位号
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      captureProps: {
        imgUrl: '',
      },
      flipHorizontal: false, // 水平翻转图像
      defaultCameraView: '',
      showPipeExtraction: false,
      showPipeFlowAnalysis: false,
    }
  },
  watch: {
    showCloseScreen(val) {
      if (val) {
        this.spanLeft = 12
        this.spanRight = 12
      } else {
        this.spanLeft = 24
        this.spanRight = 0
      }
    },
    '$route.path': {
      immediate: true,
      handler(val) {
        if (val.includes('pipe-extraction')) {
          this.showPipeExtraction = true
        } else if (val.includes('pipe-flow-analysis')) {
          this.showPipeFlowAnalysis = true
        }
      },
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    // 获取项目信息
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 生成随机数
    randomId() {
      let Num = ''
      for (let i = 0; i < 6; i = i + 1) {
        Num += Math.floor(Math.random() * 10)
      }
      return Num
    },
    componentTop() {
      return this.bitHeight.isZoom ? `${parseInt(this.bitHeight.minHeight, 10) + 8}rem` : '6.6rem'
    },
    // 获取是否需要广告牌
    ifAddBoard() {
      const obj = _.find(this.systemParams, { parameterCode: 'ifAddBoard' })
      return obj ? obj.parameterValue : false
    },
    standardId() {
      return this.$route.query.standardId || localStorage.getItem('standardId')
    },
    classId() {
      return this.$route.query.classId
    },
    isVersion() {
      return this.$route.query.isVersion
    },
    cloudRender() {
      return cloudRender
    },
  },
  methods: {
    async getAttrKeys(key) {
      const cameraAttrRes = await DocumentManagementService.getEntityPropertyList({
        class_id: this.$route.query.classId,
        keyword: key,
      })
      if (
        cameraAttrRes &&
        cameraAttrRes.code === 0 &&
        cameraAttrRes.data &&
        cameraAttrRes.data.length > 0
      ) {
        const cameraAttr = cameraAttrRes.data[0]
        return `${cameraAttr.classTableName}.${cameraAttr.columnName}`
      }
      return ''
    },
    // loading
    loadingSwitch({ bol, title }) {
      console.log(this.currentModel, 'currentModel')
      this.animationLoading = bol
      this.loadingTitle = title
    },
    annotationClick(val) {
      console.log(val, 'annotationClick')
    },
    async getDefaultCameraView() {
      const key = await this.getAttrKeys('DefaultCameraView')
      const res = await DocumentManagementService.getDynamicTableData({
        classId: this.$route.query.classId || this.currentModel.classId,
        dataId: this.currentDocumentId || this.$route.query.documentId, // 切换模型后则获取当前模型的视角
      })
      if (res?.code === 0 && res.data) {
        if (key) {
          this.defaultCameraView = res.data[key] || ''
        } else {
          this.defaultCameraView = ''
          this.LLH = []
        }
      }
    },
    updateModelNode(node) {
      if (!node) {
        console.error('updateModelNode: node is undefined')
        return
      }
      this.modelNodeHandler(node)
      // EventBus.$emit('updateModelNode', node)
    },
    async modelNodeHandler(val) {
      if (val?.code && val.id && window.svgData) {
        window.svgData[window.location.href].svgHotTrigger(val.code, val.id)
      } else if (val?.code && window.svgData) {
        this.modelNodeHandlerByCode(val)
      } else if (val?.code) {
        const res = await DocumentManagementService.getTagListByCodeOrName({
          keyword: val.code,
          standardId: this.standardId,
        })
        if (res && res.data && res.data.length > 0) {
          const data = res.data.find((e) => {
            return e.code === val.code
          })
          this.isTag = true
          this.setObjectNode({
            businessId: data.id,
            code: data.code,
          })
        }
      }
    },
    async modelNodeHandlerByCode(val) {
      if (val?.code) {
        const res = await DocumentManagementService.getTagListByCodeOrName({
          keyword: val.code,
          standardId: this.standardId,
        })
        if (res && res.data && res.data.length > 0) {
          let data = res.data.find((e) => {
            return e.code === val.code
          })
          if (val.businessId) {
            data = res.data.find((e) => {
              return e.id === val.businessId
            })
          }
          this.isTag = true
          this.bitModelCode = data.code
          this.currentCode = data.code
          this.setObjectNode({
            businessId: data.id,
            code: data.code,
          })
          window.svgData[window.location.href].svgHotTrigger(data.code, data.id)
        }
      }
    },
    setObjectNode(data) {
      if (this.$refs.docRelational) {
        console.log('setObjectNode Function', this.$refs.docRelational.$refs)
        if (this.$refs.docRelational.$refs.virtualTree != undefined) {
          this.$refs.docRelational.setCurrentNode(data.businessId)
          this.$refs.docRelational.$refs.virtualTree.setCurrentKey(data.businessId)
          // // 获取高亮节点的 DOM
          this.$nextTick(() => {
            const currentNode = this.$refs.docRelational.$refs.virtualTree.$el.querySelector(
              '.el-tree-node.is-current'
            )
            console.log(
              'setObjectNode Tree',
              currentNode,
              this.$refs.docRelational.$refs.virtualTree
            )
            if (currentNode) {
              currentNode.scrollIntoView({ block: 'center', behavior: 'smooth' })
            }
          })
        }
      }
    },
    // 模型节点编辑完成
    modifyNodeEnd(timing, node) {
      this.watchNodeModifyTiming = { timing, node }
    },
    // 获取广告牌后处理modelList
    async dealAddModelList(modelListCopy) {
      // 组装广告牌的数据
      const addList = await this.initAddData()
      if (addList) {
        const addModel = await this.getAddModelPlayId()
        _.forEach(modelListCopy, (val) => {
          // 获取所有匹配Id的广告牌
          _.forEach(addList, (value) => {
            if (value.documentFileId === val.fileId) {
              value.name = '广告牌'
              value.md5 = addModel.Md5
              value.fileId = addModel.FileId
              modelListCopy.push(value)
            }
          })
        })
      }
    },
    // 获取广告牌MD5
    async getAddModelPlayId() {
      const param = {
        siteId: this.currentProject.id || ' ',
        keywords: ' ',
        stageId: ' ',
        startTime: ' ',
        endTime: ' ',
      }
      const res = await this.apiModelCenter({
        method: 'list',
        params: param,
      })
      if (res && res.Success && res.Data) {
        const [models] = _.map(res.Data, (item) => {
          return item.Models
        })
        const addModel = _.find([models][0], (o) => {
          return o.Code === 'advertisementModel'
        })
        if (addModel) {
          return addModel
        }
      }
      return null
    },
    // 获取广告牌列表
    async initAddData() {
      const listRes = await addService.addManageList({
        pageNo: 1,
        pageSize: 9999,
        SiteId: this.currentProject.id,
      })
      if (listRes && listRes.data && listRes.code === 0) {
        return listRes.data
      }
      this.$message.error(listRes.message)
      return null
    },
    // 关闭模型设置页面
    closeSetting() {
      this.showPlayerSetting = false
    },
    /**
     * @description: 截图
     * @param {*} captureScreen 截图所在的屏
     * @return {*}
     */
    async captureImage(captureScreen, type) {
      let fileId
      if (captureScreen === 'pr') {
        captureScreen = type
        fileId = captureScreen === 'main' ? this.currentModel.fileId : this.modelSplitProps.fileId
      } else {
        fileId = captureScreen === 'main' ? this.fileMainProps.fileId : this.fileSplitProps.fileId
      }
      const fileType =
        captureScreen === 'main'
          ? this.mainFileType.toLowerCase()
          : this.splitFileType.toLowerCase()
      const markType = fileType === 'pr' ? 2 : 1
      if (fileType === 'pdf') {
        window.pdfCapture()
        window.addEventListener('message', (el) => {
          if (captureScreen === 'main') {
            this.MainEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showMainEditPhoto = true
          } else {
            this.SplitEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showSplitEditPhoto = true
          }
        })
      } else if (fileType === 'svg') {
        const status = await window.svgData[window.location.href].svgCapture()
        if (!status) {
          this.$message.warning('svg未加载完成,请稍候再试！')
          return
        }
        window.addEventListener('message', (el) => {
          if (el.data.type === 'svgCapture') {
            if (captureScreen === 'main') {
              this.MainEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showMainEditPhoto = true
            } else {
              this.SplitEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showSplitEditPhoto = true
            }
          }
        })
      } else if (fileType === 'pr' && captureScreen === 'main') {
        this.isShowWaitLayer = true // 开启等待图层
        const captureDom = this.mainPlayer.config.video
        const imgUrl = await this.getConvertToImage(captureDom, {
          rotate: this.rotationAngle,
          flipHorizontal: true,
        })
        // const fileLocation = await PlayerUtils.call(
        //   this.mainPlayer.Native.CameraAnimation.cameraParam
        // )
        // 暂无上接口，暂用
        const fileLocation = await this.mainPlayer.Native.Camera.currentParam()
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showSplitEditPhoto = true
        }
      } else if (this.imgTypeList.includes(fileType)) {
        const captureDom = document.querySelector('#mainImgDom')
        const imgUrl = await this.getConvertToImage(captureDom)
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId: this.mainFileId,
            markType,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId,
            markType,
          }
          this.showMainEditPhoto = true
        }
      }
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      const width = parseInt(window.getComputedStyle(container).width, 10)
      const height = parseInt(window.getComputedStyle(container).height, 10)
      // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: false,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        this.isShowWaitLayer = false // 关闭等待图层

        // 如果需要旋转或翻转，创建新的canvas进行处理
        if (options.rotate) {
          const rotatedCanvas = document.createElement('canvas')
          rotatedCanvas.width = canvas.width
          rotatedCanvas.height = canvas.height
          const ctx = rotatedCanvas.getContext('2d')

          // 设置更好的图像渲染质量
          ctx.imageSmoothingEnabled = true
          ctx.imageSmoothingQuality = 'high'

          // 保存当前状态
          ctx.save()

          // 移动到画布中心
          ctx.translate(canvas.width / 2, canvas.height / 2)

          // 水平镜像翻转（沿Y轴翻转）
          if (options.flipHorizontal) {
            ctx.scale(-1, 1)
          }

          // 旋转
          if (options.rotate !== 0) {
            ctx.rotate((options.rotate * Math.PI) / 180)
          }

          // 绘制图像，注意调整原点位置
          ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height)

          // 恢复状态
          ctx.restore()

          return rotatedCanvas.toDataURL('image/png')
        }

        return canvas.toDataURL('image/png')
      })
    },
    /**
     * @description: 展示标记
     * @param {*} node 标记信息
     * @return {*}
     */
    showMarker(nodes, type) {
      const node = nodes[0]
      if (type === 'split') {
        // 分屏过来的
        this.showSplitEditPhoto = true
        this.SplitEditViewProps = {
          imgUrl: this.currentEnv.VUE_APP_PLANT_SERVER + node.screenshotUrl,
          showMark: true,
          name: node.name,
          remark: node.remark,
          position: node.cameraPosition,
        }
      } else {
        this.showMainEditPhoto = true
        this.MainEditViewProps = {
          imgUrl: this.currentEnv.VUE_APP_PLANT_SERVER + node.screenshotUrl,
          showMark: true,
          name: node.name,
          remark: node.remark,
          position: node.cameraPosition,
        }
      }
    },
    sendBasicComponents(val) {
      this.basicComponents = val
    },
    /**
     * @description: 模型加载完成监听
     * @param {*}
     * @return {*}
     */

    LoadedAllModel() {
      this.loadedModel = true
    },
    sendPlayer(player) {
      this.mainPlayer = player // 存储实例化完成的player
      initPlayer(player)
    },
    /**
     * @description: 关联位号树的点击事件
     * @param {*} data
     * @return {*}
     */

    getModelData(data) {
      this.tagId = data.businessId
      this.isTag = data.isTag
      if (data.code) {
        this.modelNodeHandler(data)
        this.codeChangeType = data.codeChangeType || 'docClick'
        this.bitModelCode = data.code
        this.currentCode = data.code
      }
    },
    /**
     * @description: 当前code变化
     * @param {*} code
     * @return {*}
     */

    currentCodeChange(code) {
      this.codeChangeType = 'other'
      this.currentCode = code
      this.currentDocumentId = this.currentModel.documentId
    },
    // 选中工程节点信息
    handleNodeClick(data) {
      this.currentEngineerNode = _.cloneDeep(data)
    },
    // 新增模型后更新树
    updateEditTree(node) {
      this.currentCreateNode = node
      // 每次执行操作后更新
      this.currentEditMoment = moment().valueOf()
    },
    /**
     * @description:分屏
     * @param {*} data
     * @return {*}
     */

    splitScreen(data) {
      this.splitFileType = data.type
      data.isSplitData = true
      if (data.type === 'pr' || data.type === 'pprj') {
        this.newCloudRender = new CloudRender()
        this.modelSplitList = [this.loadComponentByType(data)]
        this.currentSplitDocumentId = data.documentId
        this.modelSplitProps.defaultModelId = data.documentId
      } else {
        this.fileSplitProps = this.loadComponentByType(data)
      }
      this.showCloseScreen = true
    },
    /**
     * @description: 文件加载完时的回调事件
     * @param {*} val
     * @return {*}
     */

    loadFile() {},
    /**
     * @description: svg点击事件
     * @param {*} code
     * @return {*}
     */

    svgClick(code) {
      // code = 'T0BHE04B1-01'
      this.codeChangeType = 'svgClick'
      this.currentCode = code
      this.currentDocumentId = this.currentModel.documentId
      this.getInfoByCode(code)
    },
    /**
     * @description: 根据code取得位号的基本信息
     * @param {*} code
     * @return {*}
     */

    getInfoByCode(code) {
      this.docModelCode = `${code},${moment().valueOf()}`
      this.bitModelCode = code
    },
    /**
     * @description: 模型点选数据处理
     * @param {*} data
     * @param {*} type 触发的方法
     * @return {*}
     */

    async modelClick(data, type) {
      this.codeChangeType = type
      this.currentCode = data.code
      // if (this.$route.query.engineerId) {
      //   const itemInfo = await this.mainPlayer.Native.ModelTree.getItemInfo(data.parentItem)
      //   const nodeInfo = await this.mainPlayer.Native.NodeProxy.getNodeInfo(itemInfo.nodePtr)
      //   this.currentEngineerNode = nodeInfo
      //   return
      // }
      if (this.currentDocumentId !== data.documentId) {
        this.currentModel = _.find(this.fileDetailList, ['documentId', data.documentId])
        this.currentDocumentId = data.documentId
      }
      if (this.mainFileType === 'svg' || this.splitFileType === 'svg') {
        window.svgData[window.location.href].svgHotTrigger(data.code)
      }
      this.getInfoByCode(data.code)
    },
    /**
     * @description: 切换模型文件,移动相机至当前模型
     * @param {*} model 模型基本信息
     * @return {*}
     */

    async changeModelData(model) {
      this.loadingSwitch({ bol: true, title: '模型切换中，请勿操作' })
      if (this.$route.query.sceneId) {
        this.currentModel = _.find(this.fileDetailList, ['documentId', model.documentId])
        // 存储当前选中模型的基本信息
        this.docModelCode = ''
        this.currentDocumentId = model.documentId
      } else if (this.$route.query.engineerId) {
        // console.log(111111111)
      } else {
        this.currentModel = model
        this.curModelStandardId = model.standardId || ''
        this.modelProps.defaultModelId = model.documentId
        this.currentDocumentId = model.documentId
        const firstOpen = _.isEmpty(this.modelList)
        await this.getDefaultCameraView() // 切换模型更新默认视角
        // 切换模型
        this.modelList = [this.loadComponentByType(model)]
        // 清除前一个模型的状态
        _.forEach(this.businessTabInfo.selectBusinessList, (item) => {
          this.removeTagsStatus(item)
        })
        this.businessTabInfo.selectBusinessList = []
        // 需要打开弹框的组件
        if (firstOpen && this.$route.query.type) {
          this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
        }
      }
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getFileDetail(id) {
      const params = {
        id,
        standardId: this.standardId,
      }
      // 是否是历史版本预览
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentManagementService.getDocumentDetail(params)
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.split(fileDetail.fileNameOrigin, '.')
          .pop()
          .toLowerCase()
        return fileDetail
      }
      return {}
    },
    /**
     * @description: 根据不同的文件类型加载不同的组件
     * @param {*} fileDetail 文件详情
     * @return {*}
     */

    loadComponentByType(fileDetail) {
      console.log(this.defaultCameraView, 'this.defaultCameraView')
      if (this.modelTypes.includes(fileDetail.type)) {
        const query = fileDetail.attrObject || {
          Latitude: '',
          Longitude: '',
          Z_Axis_Angle: '',
          Y_Axis_Angle: '',
          Elevation: '',
          IsAutoFollowFloor: '',
          Model_Offset: 0,
          material: '',
        }
        if (fileDetail.isSplitData) {
          // 分屏的模型数据另外处理
          return {
            ...query,
            documentId: fileDetail.documentId,
            md5: fileDetail.md5,
            name: fileDetail.fileName || fileDetail.nodeName,
            fileId: fileDetail.fileId,
            textureInfoId: fileDetail.textureInfoId,
            modelInfoId: fileDetail.modelInfoId,
            CameraPosition: null,
            type: fileDetail.type,
          }
        }
        return {
          ...query,
          documentId: fileDetail.documentId,
          md5: fileDetail.fileOriginMd5,
          name: fileDetail.fileNameOrigin,
          fileId: fileDetail.fileId,
          textureInfoId: fileDetail.textureInfoId,
          modelInfoId: fileDetail.modelInfoId,
          CameraPosition: this.defaultCameraView,
          type: fileDetail.type,
        }
      }
      switch (fileDetail.type) {
        case 'svg':
          return {
            id: `svgFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `/lib/svgView/index.html?file=${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
        case 'pdf':
          return {
            id: `pdfFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `/lib/pdfjs/web/viewer.html?file=${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
        case 'ht':
          return {}
        default:
          return {
            id: `defaultFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
      }
    },
    removeTagsStatus(removeTags) {
      if (this.showDialogCom.includes(removeTags)) {
        // 关闭弹框且判断弹框列表是否为空
        const removeTagIndex = _.findIndex(this.openDialogList, ['val', removeTags])
        if (removeTagIndex !== -1) {
          this.openDialogList.splice(removeTagIndex, 1)
        }
        if (!_.isEmpty(this.openDialogList) && removeTags !== 'ModelEditTool') {
          this.openBusinessDialog(_.last(this.openDialogList))
        } else if (removeTags === 'ModelEditTool') {
          this.showModelEditTool = false
          this.componentHeight =
            this.showBitComponent || this.showModelEditTool
              ? this.businessTabInfo.currentDialog.minHeight
              : this.businessTabInfo.currentDialog.maxHeight
        } else {
          // 清除弹框状态，菜单栏状态
          this.businessTabInfo.currentDialog = this.$options.data().businessTabInfo.currentDialog
          this.bitHeight = {
            minHeight: '30rem',
            maxHeight: '45rem',
            isZoom: false,
          }
          this.showBusinessDialog = false
          this.componentHeight = ''
        }
      } else if (this.unOpenDialog.includes(removeTags)) {
        // 关闭非弹框组件
        this.switchUnOpenDialog(removeTags, false)
      }
    },
    setTabBarStatus(tag) {
      let removeTags = []
      // 切换
      removeTags = _.remove(this.businessTabInfo.selectBusinessList, (item) => {
        return item === tag.val || tag.unAllowCoexistCom.includes(item)
      })
      _.forEach(removeTags, (item) => {
        this.removeTagsStatus(item)
      })
      // 数组变化子组件未监听到变化，所以重新赋值。
      this.businessTabInfo.selectBusinessList = _.clone(this.businessTabInfo.selectBusinessList)
      if (!removeTags.includes(tag.val)) {
        if (this.showBitComponent && tag.val === 'ModelEditTool') {
          return false
        }
        this.businessTabInfo.selectBusinessList.push(tag.val)
        return true
      }
      return false
    },
    /**
     * @description: 业务按钮点击事件
     * @param {*} arg 当前点击的按钮信息
     * @return {*}
     */

    tagsBusinessClick(arg, type) {
      const tag = arg[0]
      // 不需要激活态的节点
      const unActiveNode = ['mark', 'xslx', 'gblx', 'qbxs', 'qbgb', 'xswlx', 'ycwlx']
      if (!unActiveNode.includes(tag.val)) {
        // 判断当前tag是否在selectList中
        const changeActiveBusinessTag = this.setTabBarStatus(tag)
        if (!changeActiveBusinessTag) return
        // 业务弹框点击事件
        if (this.showDialogCom.includes(tag.val)) {
          // 执行弹框打开事件
          this.openBusinessDialog(tag)
        } else if (this.unOpenDialog.includes(tag.val)) {
          // 开启指定组件
          this.switchUnOpenDialog(tag.val, true)
        }
        // 区分弹框组件与非弹框组件
        // 弹框组件，开启or关闭
      }
      if (unActiveNode.includes(tag.val)) {
        if (tag.val === 'mark') {
          this.captureImage('pr', type)
        } else {
          // 开启指定组件
          this.switchUnOpenDialog(tag.val, true)
        }
      }
    },
    /**
     * @description: 执行非弹框组件
     * @param {*} val tag中的val
     * @param {*} isShow 是否显示组件
     * @return {*}
     */

    async switchUnOpenDialog(val, isShow) {
      switch (val) {
        case 'xslx':
        case 'gblx':
        case 'qbxs':
        case 'qbgb':
        case 'xswlx':
        case 'ycwlx':
          this.$refs.PipeFlowDirection.todoOperation(val)
          break
        default:
          break
      }
    },
    switchDialog(row) {
      if (row.val === this.businessTabInfo.currentDialog.val) {
        // 清除弹框状态，菜单栏状态
        this.businessTabInfo.currentDialog = this.$options.data().businessTabInfo.currentDialog
        this.showBusinessComponents = ''
        this.bitHeight = {
          minHeight: '30rem',
          maxHeight: '45rem',
          isZoom: false,
        }
        return
      }
      this.openBusinessDialog(row)
    },
    /**
     * @description: 需要打开弹框的组件
     * @param {*} data
     * @return {*}
     */

    openBusinessDialog(data) {
      if (data.val === 'ModelEditTool' && !this.showBitComponent) {
        this.showModelEditTool = true
        this.componentHeight = this.showBusinessDialog
          ? this.businessTabInfo.currentDialog.minHeight
          : ''
        return
      }
      // 开启弹框 or新增弹框
      if (
        _.isEmpty(_.find(this.openDialogList, ['val', data.val])) &&
        data.val !== 'ModelEditTool'
      ) {
        this.openDialogList.push({ ...data, expand: true })
      }
      if (data.val !== 'ModelEditTool') {
        this.businessTabInfo.currentDialog = data
        this.showBusinessDialog = true
        this.showBusinessComponents = data.val
      }

      this.componentHeight =
        this.showBitComponent || this.showModelEditTool
          ? this.businessTabInfo.currentDialog.minHeight
          : this.businessTabInfo.currentDialog.maxHeight
      if (this.showBitComponent) {
        const val = parseInt('50rem', 10) - parseInt(this.componentHeight, 10)
        this.bitHeight = {
          minHeight: `${val}rem`,
          maxHeight: `${val}rem`,
          isZoom: true,
        }
      }
      if (!this.showBusinessDialog) {
        this.bitHeight = {
          minHeight: '30rem',
          maxHeight: '45rem',
          isZoom: false,
        }
      }
    },
    /**
     * @description:关闭业务组件弹框时的回调
     * @param {*}
     * @return {*}
     */

    closeBusinessComponent(val) {
      const currentCom = _.find(this.businessTabBar, ['val', val])
      if (currentCom) {
        this.setTabBarStatus(currentCom)
      }
    },
    /**
     * @description:位号弹框高度需要根据是否显示组件弹框而定
     * @param {*} bol
     * @return {*}
     */

    showBit(bol) {
      if (bol && this.showModelEditTool) {
        this.showModelEditTool = false
        this.closeBusinessComponent('ModelEditTool')
      }
      this.showBitComponent = bol
      if (this.businessTabInfo.currentDialog) {
        this.componentHeight = this.showBitComponent
          ? this.businessTabInfo.currentDialog.minHeight
          : this.businessTabInfo.currentDialog.maxHeight
        if (this.showBitComponent && this.showBusinessDialog) {
          const val = parseInt('50rem', 10) - parseInt(this.componentHeight, 10)
          this.bitHeight = {
            minHeight: `${val}rem`,
            maxHeight: `${val}rem`,
            isZoom: true,
          }
        } else {
          this.bitHeight = {
            minHeight: '30rem',
            maxHeight: '45rem',
            isZoom: false,
          }
        }
      }
    },
    /**
     * @description: 根据配置文件获取互斥策略
     * @param {*}
     * @return {*}
     */

    async getTabBarTactics() {
      // 根据系统参数设置底部工具栏
      const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
      const res = this.basePath
        ? docViewTabBarTactics
        : await $.ajax('/static/docViewTabBarTactics.json')
      if (res.basic && res.business) {
        this.basicTabBar = _.map(this.basicTabBar, (tab) => {
          if (tab.children) {
            tab.children = _.map(tab.children, (tabChild) => {
              return {
                ...tabChild,
                unAllowCoexistCom: res.basic[tabChild.val],
              }
            })
          }
          return {
            ...tab,
            unAllowCoexistCom: res.basic[tab.val] || [],
          }
        })
        this.businessAllTabBar = _.map(this.businessAllTabBar, (businessTab) => {
          if (businessTab.children) {
            businessTab.children = _.map(businessTab.children, (businessTabChild) => {
              return {
                ...businessTabChild,
                unAllowCoexistCom: res.business[businessTabChild.val] || [],
              }
            })
          }
          return {
            ...businessTab,
            unAllowCoexistCom: res.business[businessTab.val] || [],
          }
        })
        // if (this.modelProps && this.modelProps.sceneOpenType === 0) {
        //   this.basicTabBar = _.filter(this.basicTabBar, (el) => {
        //     return !res.notDisplayByOpenGis.includes(el.val)
        //   })
        //   this.businessAllTabBar = _.filter(this.businessAllTabBar, (el) => {
        //     return !res.notDisplayByOpenGis.includes(el.val)
        //   })
        // }
        if (!_.isEmpty(modelTool.parameterValue)) {
          const barList = modelTool.parameterValue.split(',')
          this.businessTabBar = _.filter(this.businessAllTabBar, (tag) => {
            return _.indexOf(barList, tag.name) !== -1
          })
        }
        if (this.$route.query.engineerId) {
          _.remove(this.businessTabBar, (tag) => {
            return tag.val === 'DataMonitoring' || tag.val === 'DeviceDetail'
          })
          _.remove(this.basicTabBar, (tag) => {
            return tag.val === 'ModelTree'
          })
          this.basicTabBar.push({
            name: '模型节点编辑',
            val: 'NodeEditTree',
            maxHeight: '35rem',
            minHeight: '35rem',
            iconName: 'icon-mxjd',
            unAllowCoexistCom: [],
          })
        }
      }
    },
    getUrlParam(url, name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`) // 构造一个含有目标参数的正则表达式对象
      const r = url.match(reg) // 匹配目标参数
      if (r != null) return unescape(r[2])
      return null // 返回参数值
    },
  },
  async created() {
    const token = Wiz.AuthHooks.GetToken()
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    this.currentCode = this.$route.query.code || ''
    // 根据系统参数设置底部工具栏
    // const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
    this.fileDetailList = []
    // 从模型中心过来
    if (this.$route.query.documentId) {
      this.relation = !this.$route.query.withoutRelation
      const gisAttrs = ['IsGisLoad', 'LLH']
      const gisAttrKeys = []
      for (let i = 0; i < gisAttrs.length; i += 1) {
        gisAttrKeys.push(this.getAttrKeys(gisAttrs[i]))
      }
      this.gisAttrKeys = await Promise.all(gisAttrKeys)
      await this.getDefaultCameraView()
      // 获取file详情
      this.fileDetailList.push(await this.getFileDetail(this.$route.query.documentId))
      // this.modelProps.defaultModelId = this.fileDetailList[0].documentId
      console.log(this.fileDetailList, 'fileDetailList')
      this.modelProps.defaultModelId = this.$route.query.documentId
      this.currentDocumentId = this.$route.query.documentId
    } else if (this.$route.query.sceneId) {
      // 场景
      // 根据场景获取documentIdList
      const res = await SceneCenter.getSceneDetail({ id: this.$route.query.sceneId })
      if (res && res.code === 0 && res.data) {
        for (let i = 0; i < res.data.models.length; i = i + 1) {
          const model = res.data.models[i]
          this.fileDetailList.push({
            ...(await this.getFileDetail(model.modelDocumentId)),
            aniId: model.aniId,
            aniName: model.aniName,
            aniMd5: model.aniMd5,
          })
        }
        this.modelProps = {
          defaultModelId: res.data.defaultModelId || res.data.models[0].modelDocumentId,
          sceneOpenType: res.data.sceneOpenType,
        }
      }
    } else {
      // 未传入documentId or sceneId 则默认加载模型组件
      this.mainFileType = 'pr'
      // 获取底部工具栏的互斥策略, 根据加载的场景不同，显示不同的tabBar
      // await this.getTabBarTactics()
      // 需要打开弹框的组件
      if (this.$route.query.type && this.$route.query.documentId) {
        this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
      }
      return
    }
    // 获取底部工具栏的互斥策略, 根据加载的场景不同，显示不同的tabBar
    // await this.getTabBarTactics()
    // 需要打开弹框的组件
    if (this.$route.query.type && this.$route.query.documentId) {
      this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
    }
    this.currentModel = this.modelProps.defaultModelId
      ? _.find(this.fileDetailList, ['documentId', this.modelProps.defaultModelId])
      : this.fileDetailList[0]
    this.currentDocumentId = this.modelProps.defaultModelId
    this.mainFileType = this.currentModel.type
    // 添加材质ID
    this.currentModel.textureInfoId = this.$route.query.textureInfoId
    // 添加模型ID
    this.currentModel.modelInfoId = this.$route.query.modelInfoId
    // 根据不同的文件类型加载不同的组件
    const modelListCopy = []
    const modelTypes = [
      'pr',
      'pprj',
      'rvm',
      'fbx',
      'vue',
      'shp',
      'zip',
      'gltf',
      'glb',
      'las',
      'prd',
      'xml',
      'obj',
      '3mf',
      'blend',
      '3ds',
      'stl',
      'dae',
      'fbxSkeleton',
      'step',
      'stp',
    ]
    if (modelTypes.includes(this.mainFileType)) {
      this.modelList = []
      _.forEach(this.fileDetailList, (file) => {
        modelListCopy.push(this.loadComponentByType(file))
      })
      if (this.ifAddBoard) {
        await this.dealAddModelList(modelListCopy)
      }
      this.modelList = _.cloneDeep(modelListCopy)
      console.log(this.modelList, 'modelList')
    } else {
      this.fileMainProps = this.loadComponentByType(this.fileDetailList[0])
    }
  },
  beforeDestroy() {
    sessionStorage.clear() // 主要针对刷新清理掉材质缓存信息
  },
}
</script>
<style lang="scss" scoped>

.split_icon {
  bottom: 3px;
  right: 10px;
}
.model-top {
  top: 0;
  height: 65px;
  flex-direction: row;
  background-color: transparent;
  font-weight: bold;
  z-index: 100;
  .anchor-pos {
    font-weight: normal;
    top: 2px;
    left: 0;
  }
  .top-mid,
  .top-left,
  .top-right {
    height: 100%;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .top-parent-left,
  .top-parent-right {
    width: calc(50% - 250px);
    overflow: hidden;
  }
  .top-left {
    width: calc(100% + 260px);
    background-position: right;
    background-image: url('../../assets/images/left.png');
  }
  .top-mid {
    width: 500px;
    text-align: center;
    background-position: center;
    background-image: url('../../assets/images/mid.png');
  }
  .top-right {
    width: calc(100% + 260px);
    background-position: left;
    background-image: url('../../assets/images/right.png');
  }
}
.model-top-font,
.anchor-pos {
  background-image: linear-gradient(top, #ffffff, #99adcc);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.model-top-font {
  max-width: 1052px;
  top: 10px;
  z-index: 999;
  text-align: center;
}
.wait_layer {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2002;
  top: 0px;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.flex-row-end {
  justify-content: flex-end;
}
.flex-row-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
}
.loading-container i {
  font-size: 32px;
  margin-bottom: 10px;
}
.rotation-settings-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  .rotation-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .flip-option {
    margin-top: 20px;
  }
}
.annotation-list-dialog {
  .annotation-list {
    max-height: 600px;
    overflow-y: auto;

    .annotation-items {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .annotation-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .annotation-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .annotation-title {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          text-align: center;
        }

        .annotation-time {
          font-size: 14px;
          color: #909399;
        }
      }

      .annotation-content {
        display: flex;
        justify-content: center;

        .annotation-image {
          max-width: 100%;
          max-height: 400px;
          object-fit: contain;
        }
      }
    }
  }
}
.annotation-list-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;

  .annotation-list-header {
    height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }

    .close-icon {
      font-size: 20px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .annotation-list {
    flex: 1;
    overflow-y: auto;
    padding: 20px;

    .annotation-items {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .annotation-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .annotation-header {
        margin-bottom: 10px;

        .annotation-title {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
        }
      }

      .annotation-content {
        display: flex;
        justify-content: center;

        .annotation-image {
          width: 100%;
          max-height: 300px;
          object-fit: contain;
        }

        .image-loading,
        .image-error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 200px;
          background-color: #f5f7fa;
          color: #909399;

          i {
            font-size: 28px;
            margin-bottom: 8px;
          }

          p {
            margin: 0;
            font-size: 14px;
          }
        }

        .image-error {
          cursor: default;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
}
.annotation-content {
  position: relative;

  .delete-annotation-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 77, 79, 0.8);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #ff4d4f;
      transform: scale(1.1);
    }

    i {
      color: #fff;
      font-size: 14px;
    }
  }
}
.model_switch_loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #00000042;
  .switch_loading_box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .switch_loading_title {
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
      position: absolute;
      top: calc(50% + 24px);
    }
    .loading_action {
      position: absolute;
      top: calc(50% - 24px);
      left: calc(50% - 24px);
      width: 48px;
      height: 48px;
      border-radius: 50%;
      transform: perspective(128px) rotateX(30deg);
      .inner {
        position: absolute;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        background-color: #1edeff;
        border-radius: 50%;
      }
      .inner.one {
        left: 0%;
        top: 0%;
        animation: move-right 1s ease-out infinite;
      }
      .inner.two {
        right: 0%;
        top: 0%;
        animation: move-down 1s ease-in-out infinite;
      }
      .inner.three {
        right: 0%;
        bottom: 0%;
        animation: move-left 1s ease-in-out infinite;
      }
      .inner.four {
        left: 0%;
        bottom: 0%;
        animation: move-up 1s ease-out infinite;
      }
    }
  }
}
@keyframes move-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(32px);
  }
}
@keyframes move-down {
  0% {
    transform: translateY();
  }
  100% {
    transform: translateY(32px);
  }
}
@keyframes move-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-32px);
  }
}
@keyframes move-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-32px);
  }
}
.i-h-30px {
  height: 30px !important;
}
::v-deep .bit-relational-box {
  .icon-expand-site-basic {
    display: none;
  }
  .component-container {
    right: 0;
  }
}

</style>
